import { render, staticRenderFns } from "./Content6NewsBox.vue?vue&type=template&id=27448e17&scoped=true&"
import script from "./Content6NewsBox.vue?vue&type=script&lang=js&"
export * from "./Content6NewsBox.vue?vue&type=script&lang=js&"
import style0 from "./Content6NewsBox.vue?vue&type=style&index=0&id=27448e17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27448e17",
  null
  
)

export default component.exports